import { render, staticRenderFns } from "./BasicProperties.vue?vue&type=template&id=06941c40&scoped=true"
import script from "./BasicProperties.vue?vue&type=script&lang=js"
export * from "./BasicProperties.vue?vue&type=script&lang=js"
import style0 from "./BasicProperties.vue?vue&type=style&index=0&id=06941c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06941c40",
  null
  
)

export default component.exports